import React from "react";
import BankReco from './Bank_Reconciliation';

const BankRecoApp = () =>{
    return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Bank Reconciliation</h5>
          </div>
        </div>
        <BankReco />
      </div>
    </div >
  );
};

export default BankRecoApp;
